/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectInstance} from "../models/object-instance";
import {ObjectService} from "../services/object.service";
import { Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {ObjectCategory} from "../models/object-category";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
export class AssetInstancesPagingResolver implements Resolve<PagedResults<ObjectInstance>> {

  constructor(
    private objectService: ObjectService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ObjectInstance>> {
    // Get the Number of Assets to load from the data passed in the route (if it exists)
    let numberOfAssets: number = route.data['assetsPerPage'];
    if (numberOfAssets == null || numberOfAssets < 1) {
      // If nothing was passed in or an invalid value found, revert to the default
      numberOfAssets = PAGING_ITEMS_PER_PAGE;
    }
    
    try {
      return await this.objectService.getAllObjectInstancesForCategoryPaging(ObjectCategory.ASSET, 0, numberOfAssets, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Asset Instances... Error: " + error, error);
    }
  }

}
